<template>
  <div>
    <ul>
      <li
        v-for="(item, index) in products"
        :key="index"
      >
        <div class="product-row">
          <div class="product-image">
            <img
              :src="getImagePath(item.product.mainPhoto)"
              alt=""
            >
          </div>
          <span class="product-title">
            {{ item.product.title }}
          </span>
          <span class="product-size">{{ item.size }}</span>
          <span class="product-price">{{ item.product.price }} PLN</span>
          <span class="product-amount">x{{ item.amount }}</span>
          <span class="product-total"> {{ item.amount * item.product.price }} PLN</span>
          <div
            v-if="showButtons"
            class="product-button-wrapper"
          >
            <button
              class="btn product-button"
              @click="removeFromCart(item.product._id, item.size)"
            >
              -
            </button>
          </div>
        </div>
      </li>
    </ul>
    <div
      v-if="shipping"
      class="shipping-method"
    >
      <input
        id="send"
        v-model="addShippingLocal"
        value="true"
        type="radio"
        class="form-check-input"
        @change="onShippingChange()"
      >
      <label
        class="form-check-label"
        for="send"
      >
        {{ strings.summarise.addShipping_ }}
      </label>
    </div>
    <div
      v-if="shipping"
      class="shipping-method"
    >
      <input
        id="notSend"
        v-model="addShippingLocal"
        type="radio"
        value="false"
        class="form-check-input"
        @change="onShippingChange()"
      >
      <label
        class="form-check-label"
        for="notSend"
      >
        {{ strings.summarise.notAddShipping_ }}
      </label>
    </div>

    <div class="cart-total">
      <p v-if="shipping">
        {{ strings.cart.shipping_ }}: {{ addShipping ? shipping : 0 }} PLN
      </p>
      <p :class="{'old-price': newTotal}">
        {{ strings.cart.totalMoney_ }}: {{ addShipping && shipping ? (totalPrice + shipping).toFixed(2) : totalPrice.toFixed(2) }} PLN
      </p>
      <p v-if="newTotal">
        {{ shipping && addShipping ? (newTotal + shipping).toFixed(2) : newTotal.toFixed(2) }} PLN
      </p>
    </div>
  </div>
</template>

<script>

import utils from '@/helpers/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'CartProducts',
  props: {
    products: {
      type: Array,
      default () {
        return []
      }
    },
    totalPrice: {
      type: Number,
      default () {
        return 0
      }
    },
    removeFromCart: {
      type: Function,
      default () {
        return undefined
      }
    },
    showButtons: {
      type: Boolean,
      default () {
        return true
      }
    },
    newTotal: {
      type: Number,
      default () {
        return null
      }
    },
    shipping: {
      type: Number,
      default () {
        return null
      }
    },
    addShipping: {
      type: Boolean,
      default () {
        return true
      }
    },
    onShippingChange: {
      type: Function,
      default () {
        return () => {}
      }
    }
  },
  data () {
    return {
      addShippingLocal: Boolean(this.addShipping)
    }
  },
  computed: {
    ...mapGetters([
      'strings'
    ])
  },
  methods: {
    getImagePath (productImgPath) {
      return utils.getImagePath(productImgPath)
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  padding-top: 100px;
}

ul {
  list-style: none;
  padding: 0;
  margin-bottom: 60px;
}
.product-row {
  padding: 10px;
  width: 100%;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-rows: 30px 30px 30px;
  text-align: left;
  letter-spacing: 1.7px;
  column-gap: 5px;
}
.product-row .product-title {
  letter-spacing: 1.5px;
  text-transform: uppercase;
  grid-column: 2/4;
  grid-row: 1;
}
.product-row .product-image {
  grid-column: 1;
  grid-row: 1/2;
}
.product-row .product-image img {
  width: 90%;
}
.product-row .product-size {
  grid-column: 2;
  grid-row: 2;
  text-transform: uppercase;
  font-weight: bold;
}
.product-row .product-price {
  grid-column: 2;
  grid-row: 3;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.8rem;
}
.product-row .product-amount {
  grid-column: 3;
  grid-row: 3;
  font-size: 0.8rem;
}
.product-row .product-total {
  grid-column: 4;
  grid-row: 3;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.8rem;
}
.product-row .product-button-wrapper {
  grid-column: 4;
  grid-row: 2;
  margin-top: -10px;
}
.product-button {
  background-color: #000000;
  border: 1px solid #000000;
  border-radius: 0;
  color: #ffffff;
  padding: 2px 20px;
}
.shipping-method {
  text-align: left;
}
.cart-total {
  text-align: right;
  letter-spacing: 2.3px;
  font-weight: bold;
  margin-top: 25px;
}
.old-price {
  font-size: 0.8rem;
  text-decoration: line-through;
}
@media (min-width: 992px) {
  .wrapper {
    max-width: 800px;
  }
  .product-row {
    padding: 0;
    display: grid;
    grid-template-columns: 100px calc(50% - 100px) 25% 25%;
    grid-template-rows: 40px 30px 30px;
    text-align: left;
    letter-spacing: 1.7px;
    column-gap: 5px;
  }
  .product-row .product-total {
    text-align: right;
  }
  .product-row .product-button-wrapper {
    text-align: right;
  }
  .cart-total {
    margin-top: 60px;
    margin-right: -16px;
    font-size: 1.5rem;
  }
}
</style>
